import React from 'react';
import createSvgIcon from './utils/createSvgIcon';

export default createSvgIcon(
  <React.Fragment><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" /><path fill="none" d="M0 0h24v24H0z" /></React.Fragment>
, 'NavigateBefore');
